<div class="relative">
	<app-header class="header mat-elevation-z4"></app-header>
	<mat-sidenav-container>
		<mat-sidenav mode="side" disableClose="true" opened="{{ sidenavOpened | async }}"
			class="sidenav header-margin mat-elevation-z4">
			<app-main-menu></app-main-menu>
		</mat-sidenav>
		<mat-sidenav-content>
			<div class="header-margin content">
				<router-outlet></router-outlet>
			</div>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>